import classNames from 'classnames';
import { numberToString, secondsToHms } from 'common/utils';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import { useContext, useMemo } from 'react';
import { LecturePaidType, LectureType } from 'service/course';
import { CourseDetailsContext } from '..';
import useGlobalStore from 'store/global';
import styles from './LecturesMenu.module.scss';
const LecturesMenu = () => {
  const {
    courseInfo,
    currentLecture,
    viewdLectureIds,
    setCurrentLecture,
    setOpenCoursePaywall,
  } = useContext(CourseDetailsContext);
  // const setSnackbarMessage = useGlobalStore(
  //   (state) => state.setSnackbarMessage
  // );
  const currentAuth = useGlobalStore((state) => state.currentAuth);
  const showLogin = useGlobalStore((state) => state.showLogin);

  const totalDuration = useMemo(() => {
    return (courseInfo.lectures || []).reduce(
      (result: number, item: LectureType) =>
        result + item.lecture_media?.duration || 0,
      0
    );
  }, [courseInfo.lectures]);

  const handleChooseLecture = (lecture: LectureType) => {
    if (!currentAuth) {
      showLogin({});
      return;
    }
    const newLectureIndex = courseInfo.lectures?.findIndex(
      (lec) => lec.id === lecture.id
    );
    if (newLectureIndex < 0) return;
    // only first lecture is free
    if (lecture.type === LecturePaidType.Free) {
      setCurrentLecture(lecture);
      return;
    }
    // if can watch
    if (courseInfo.is_owner || courseInfo.is_purchased) {
      setCurrentLecture(lecture);
    } else {
      // if can't watch => open paywall
      setOpenCoursePaywall(true);
      return;
    }
  };
  const totalViewCount = useMemo(() => {
    return (courseInfo.lectures || []).reduce(
      (result: number, item: LectureType) => result + item.view_count,
      0
    );
  }, [courseInfo.lectures]);
  return (
    <div className={styles.lecturesMenuWrapper}>
      <div className={styles.lecturesMenu}>
        <div className={styles.menuTop}>
          <div className={styles.courseTitle}>{courseInfo.title}</div>
          {!courseInfo.is_purchased && !courseInfo.is_owner && (
            <div className={styles.purchaseInfo}>
              <div className={styles.openPaywallButton}>
                <Button
                  text="コースを受講する"
                  fullWidth
                  onClick={() => {
                    if (!currentAuth) {
                      showLogin({});
                      return;
                    }
                    setOpenCoursePaywall(true);
                  }}
                />
              </div>
            </div>
          )}
          <div className={styles.courseTotalInfo}>
            <div className={styles.lecturesCount}>
              レクチャー ({courseInfo.lectures?.length})
            </div>
            <div className={styles.minutes}>
              <div className={styles.durationWrapper}>
                <span className={styles.icon}>
                  <Icon name="video" width={16} height={16} />
                </span>
                <div className={styles.number}>
                  {secondsToHms(totalDuration)}
                </div>
              </div>

              <div className={styles.viewCount}>
                <span className={styles.icon}>
                  <Icon name="view-black" width={18} height={18} />
                </span>
                <div className={styles.number}>
                  {numberToString(totalViewCount, 1)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.lecturesList}>
          {courseInfo.lectures?.map((lecture, index) => {
            const idsViewed =
              lecture.is_viewed || viewdLectureIds.includes(lecture.id);
            return (
              <div
                key={lecture.id}
                className={classNames(styles.lectureItem, {
                  [styles.currentItem]: lecture.id === currentLecture?.id,
                })}
              >
                <div className={styles.lectureStatus}>
                  {lecture.id === currentLecture?.id ? (
                    idsViewed ? (
                      <Icon name="done" width={16} height={16} />
                    ) : (
                      <div className={styles.doing}></div>
                    )
                  ) : idsViewed ? (
                    <Icon name="done" width={16} height={16} />
                  ) : (
                    <div className={styles.notYet}></div>
                  )}
                </div>
                <div className={styles.lectureInfo}>
                  <div className={styles.lectureTitleWrapper}>
                    <div className={styles.lectureIndex}>{index + 1}.</div>
                    <div
                      className={styles.lectureTitle}
                      onClick={() => handleChooseLecture(lecture)}
                    >
                      {lecture.title}
                    </div>
                  </div>
                  <div className={styles.lectureDuration}>
                    <div className={styles.durationWrapper}>
                      <span className={styles.icon}>
                        <Icon name="video" width={16} height={16} />
                      </span>
                      <div className={styles.number}>
                        {secondsToHms(lecture.lecture_media.duration)}
                      </div>
                    </div>

                    <div className={styles.viewCount}>
                      <span className={styles.icon}>
                        <Icon name="view-black" width={18} height={18} />
                      </span>
                      <div className={styles.number}>
                        {numberToString(lecture.view_count, 1)}
                      </div>
                    </div>
                  </div>
                </div>
                {lecture.type === LecturePaidType.Free && (
                  <span className={styles.lectureType}>無料</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LecturesMenu;
